import News from 'components/Dashboard/News';
import fallbackLogo from 'statics/images/shortlogo.png'; // <-- change this with logo

export const WIDGET_COMPONENT_MAPPING = {
    news: News
};

export const DEFAULT_LOGO = fallbackLogo;
